import React from "react";
import PaginationModified from "../../../data/PaginationModified";
import Accordion from "react-bootstrap/Accordion";
import {
  convertTo12HourFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import { EyeIcon } from "../../../images/icons/icons";

const WalkinsListingsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const hasRatings = row?.ratings && row.ratings !== "{}";

          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <div
                    className="profile-name-number"
                    style={{
                      columnGap: "0",
                      height: "auto",
                    }}
                  >
                    <div className="name-number">
                      <h3 className="lead-name">{row?.name || "NA"}</h3>
                      <p className="number">{row?.mobile || ""}</p>
                      {row?.email ? (
                        <span className="value email semi-bold">
                          {row?.email || ""}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <div className="heade-info">
                          <span className="title">View More</span>
                        </div>
                      </Accordion.Header>

                      <Accordion.Body>
                        <div className="lead-multi-value-cols px20px pb20px pt20px">
                          <div className="label-value">
                            <span className="label">gender</span>
                            <span className="value">{row?.gender || "NA"}</span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">gym name</span>
                            <span className="value">
                              {row?.gym_name || "NA"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">assisted by</span>
                            <span className="value">
                              {row?.assisted_by_name || "NA"}
                              <br />
                              <small
                                style={{
                                  textTransform: "lowercase",
                                  textDecoration: "underline",
                                }}
                              >
                                {row?.assisted_by_mobile || ""}
                                <br />
                                {row?.assisted_by_email || ""}
                              </small>
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">submission type</span>
                            <span className="value">
                              {row?.submission_type || "NA"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">date added</span>
                            <span className="value">
                              {row?.date_added
                                ? formatDateTimezon(row.date_added)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">visit time</span>
                            <span className="value">
                              {row?.visit_start_time
                                ? convertTo12HourFormat(row.visit_start_time)
                                : "-"}{" "}
                              -{" "}
                              {row?.visit_end_time
                                ? convertTo12HourFormat(row.visit_end_time)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">remarks</span>
                            <span className="value">
                              {row?.remarks ? "read" : "NA"}
                            </span>
                          </div>

                          <div className="label-value flex-col">
                            <span className="label">ratings</span>
                            <span
                              className={`value ${hasRatings ? "link" : ""}`}
                              onClick={() =>
                                hasRatings &&
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  rowData: row,
                                  modName: "ratings",
                                }))
                              }
                            >
                              {hasRatings ? "view" : "NA"}
                            </span>
                          </div>
                        </div>

                        <div className="all-btns lead-btn-axceed">
                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              onClick={() =>
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  rowData: row,
                                  modName: row?.added_to_lead
                                    ? "follow-up"
                                    : "add-to-lead",
                                }))
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-plus-square-dotted"
                                viewBox="0 0 16 16"
                              >
                                <path d="M2.5 0q-.25 0-.487.048l.194.98A1.5 1.5 0 0 1 2.5 1h.458V0zm2.292 0h-.917v1h.917zm1.833 0h-.917v1h.917zm1.833 0h-.916v1h.916zm1.834 0h-.917v1h.917zm1.833 0h-.917v1h.917zM13.5 0h-.458v1h.458q.151 0 .293.029l.194-.981A2.5 2.5 0 0 0 13.5 0m2.079 1.11a2.5 2.5 0 0 0-.69-.689l-.556.831q.248.167.415.415l.83-.556zM1.11.421a2.5 2.5 0 0 0-.689.69l.831.556c.11-.164.251-.305.415-.415zM16 2.5q0-.25-.048-.487l-.98.194q.027.141.028.293v.458h1zM.048 2.013A2.5 2.5 0 0 0 0 2.5v.458h1V2.5q0-.151.029-.293zM0 3.875v.917h1v-.917zm16 .917v-.917h-1v.917zM0 5.708v.917h1v-.917zm16 .917v-.917h-1v.917zM0 7.542v.916h1v-.916zm15 .916h1v-.916h-1zM0 9.375v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .916v.917h1v-.917zm16 .917v-.917h-1v.917zm-16 .917v.458q0 .25.048.487l.98-.194A1.5 1.5 0 0 1 1 13.5v-.458zm16 .458v-.458h-1v.458q0 .151-.029.293l.981.194Q16 13.75 16 13.5M.421 14.89c.183.272.417.506.69.689l.556-.831a1.5 1.5 0 0 1-.415-.415zm14.469.689c.272-.183.506-.417.689-.69l-.831-.556c-.11.164-.251.305-.415.415l.556.83zm-12.877.373Q2.25 16 2.5 16h.458v-1H2.5q-.151 0-.293-.029zM13.5 16q.25 0 .487-.048l-.194-.98A1.5 1.5 0 0 1 13.5 15h-.458v1zm-9.625 0h.917v-1h-.917zm1.833 0h.917v-1h-.917zm1.834-1v1h.916v-1zm1.833 1h.917v-1h-.917zm1.833 0h.917v-1h-.917zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                              </svg>
                            </button>

                            <span className="btn-label">
                              {row?.added_to_lead ? "View Lead" : "Add To LMS"}
                            </span>
                          </div>

                          <div className="lead-log-box">
                            <button
                              className="lead-log view-lead"
                              onClick={() =>
                                setModValues((prevs) => ({
                                  ...prevs,
                                  isModOpen: true,
                                  modName: "view_details",
                                  rowData: row,
                                  from: "wati",
                                }))
                              }
                            >
                              <EyeIcon />
                            </button>

                            <span className="btn-label">timeline</span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          pagination={getPagination()}
        />
      </div>
    </div>
  );
};

export default WalkinsListingsMobile;
